module.exports = __webpack_public_path__ + "static/media/instagram.526bf414.svg";